import { render, staticRenderFns } from "./RenderizaFormularioComponent.vue?vue&type=template&id=12f13538&scoped=true"
import script from "./RenderizaFormularioComponent.vue?vue&type=script&lang=js"
export * from "./RenderizaFormularioComponent.vue?vue&type=script&lang=js"
import style0 from "./RenderizaFormularioComponent.vue?vue&type=style&index=0&id=12f13538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f13538",
  null
  
)

export default component.exports